"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DealLabel = void 0;
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _common = require("../../common");
var _InnerDealLabel = require("./InnerDealLabel");
var _isDealLabel = require("./isDealLabel");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const DealLabel = ({
  label,
  type,
  className,
  productCode,
  tooltipTitle,
  size
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  if (!(0, _isDealLabel.isDealLabel)(type) || !label) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Deal, {
    className: className,
    "data-testid": `${getTestId(_common.DEAL_LABEL)}-${productCode}`,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_InnerDealLabel.InnerDealLabel, {
      label: label,
      productCode: productCode,
      tooltipTitle: tooltipTitle,
      type: type,
      size: size
    })
  });
};
exports.DealLabel = DealLabel;
//# sourceMappingURL=DealLabel.js.map